<form [formGroup]="valoracionsFinalsForm">
  <div class="col" *ngIf="valoracions">
    <div class="apartat">
      <label>{{valoracions[0].preguntes[0].descripcio}}</label>
      <div class="col">
        <ng-container *ngFor="let resposta of valoracions[0].preguntes[0].respostes">    
          <label><input type="radio" [value]="resposta.id" formControlName="valoracionsFinals1"/><span>{{resposta.descripcio}}</span></label>
          <div *ngIf="resposta.idPreguntaAdicional != null && valoracionsFinalsForm.value.valoracionsFinals1 == VALORACIO_1_PREGUNTA_1_RESPOSTA_2">
            <br/>
            <select formControlName="observadorPregunta" multiple style="width: 50%" [size]="resposta.preguntesAdicionals.length">
              <option *ngFor="let preguntaAdicional of resposta.preguntesAdicionals" [value]="preguntaAdicional.id">{{preguntaAdicional.descripcio}}</option>
            </select>
            <app-ajuda id="ajuda_observador_pregunta">
              Es permet selecció múltiple marcant diverses opcions:
              
              <ul>
                <li>Per seleccionar elements no correlatius: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu seleccionar.</li>
                <li>Per seleccionar elements correlatius: mantenir premuda la tecla Shift. Clicar el primer element i després l'últim.</li>
                <li>Per desseleccionar: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu desseleccionar.</li>
              </ul>
            </app-ajuda>
          </div>
        </ng-container>
      </div>   
    </div>
    <div class="apartat">
      <label>{{valoracions[1].preguntes[0].descripcio}}</label>
      <div class="col">
        <ng-container *ngFor="let resposta of valoracions[1].preguntes[0].respostes">          
          <label><input type="radio" [value]="resposta.id" formControlName="explicacionsPregunta"/><span>{{resposta.descripcio}}</span></label>
          <div *ngIf="resposta.idPreguntaAdicional != null && valoracionsFinalsForm.value.explicacionsPregunta == VALORACIO_2_PREGUNTA_1_RESPOSTA_3">
            <br/>
            <select formControlName="observacionsFinExplicacions" multiple style="width: 50%" [size]="resposta.preguntesAdicionals.length">
              <option *ngFor="let preguntaAdicional of resposta.preguntesAdicionals" [value]="preguntaAdicional.id">{{preguntaAdicional.descripcio}}</option>
            </select>
            <app-ajuda id="ajuda_observacions_fin_explicacions">
              Es permet selecció múltiple marcant diverses opcions:
              
              <ul>
                <li>Per seleccionar elements no correlatius: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu seleccionar.</li>
                <li>Per seleccionar elements correlatius: mantenir premuda la tecla Shift. Clicar el primer element i després l'últim.</li>
                <li>Per desseleccionar: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu desseleccionar.</li>
              </ul>
            </app-ajuda>
          </div>
        </ng-container>
      </div>
    </div>
    
    <blockquote *ngIf="valoracionsFinalsForm.value.explicacionsPregunta == VALORACIO_2_PREGUNTA_1_RESPOSTA_1 || valoracionsFinalsForm.value.explicacionsPregunta == VALORACIO_2_PREGUNTA_1_RESPOSTA_3">
      <div class="apartat">
        <label>{{valoracions[2].preguntes[0].descripcio}}</label>
        <div class="row">
          <ng-container *ngFor="let resposta of valoracions[2].preguntes[0].respostes">
            <label><input type="radio" [value]="resposta.id" formControlName="grauPregunta"/><span>{{resposta.descripcio}}</span></label>
          </ng-container>          
        </div>
      </div>
      <div class="apartat">
        <label>{{valoracions[3].preguntes[0].descripcio}}</label>
        <div class="row">
          <select formControlName="accionsPregunta" multiple style="width: 50%"  [size]="valoracions[3].preguntes[0].respostes.length">
            <option *ngFor="let resposta of valoracions[3].preguntes[0].respostes" [value]="resposta.id">{{resposta.descripcio}}</option>
          </select>
          <label *ngIf="valoracionsFinalsForm.value.accionsPregunta.includes(17)">Altres accions <input type="text" formControlName="altresAccions"/></label>          
          <app-ajuda id="ajuda_accions_pregunta">
            Es permet selecció múltiple marcant diverses opcions:            
            <ul>
              <li>Per seleccionar elements no correlatius: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu seleccionar.</li>
              <li>Per seleccionar elements correlatius: mantenir premuda la tecla Shift. Clicar el primer element i després l'últim.</li>
              <li>Per desseleccionar: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu desseleccionar.</li>
            </ul>
          </app-ajuda>
        </div>
      </div>
      <div class="apartat">
        <label>{{valoracions[4].preguntes[0].descripcio}}</label>
        <div class="row">
          <ng-container *ngFor="let resposta of valoracions[4].preguntes[0].respostes">
            <label><input type="radio" [value]="resposta.id" formControlName="collaboraPregunta"/><span>{{resposta.descripcio}}</span></label>
          </ng-container>
        </div>
      </div>
    </blockquote>
    <div class="apartat">
      <label>{{valoracions[5].preguntes[0].descripcio}}</label>
      <div class="col">
        <ng-container *ngFor="let resposta of valoracions[5].preguntes[0].respostes">
          <div class="row">
            <label><input type="radio" [value]="resposta.id" formControlName="vinclePregunta"/><span>{{resposta.descripcio}}</span></label>
            <br/>
            <select *ngIf="resposta.idPreguntaAdicional != null" formControlName="vincle" size="1">
              <option value="" hidden>Trieu una opció</option>
              <option *ngFor="let preguntaAdicional of resposta.preguntesAdicionals" [ngValue]="preguntaAdicional.id">{{preguntaAdicional.descripcio}}</option>
            </select> 
          </div>
        </ng-container>
        <br/>
        <blockquote>
          <label>{{valoracions[6].preguntes[0].descripcio}}</label>
          <br/><br/>
          <ng-container *ngFor="let resposta of valoracions[6].preguntes[0].respostes">
            <label><input type="radio" [value]="resposta.id" formControlName="coneixementPregunta"/><span>{{resposta.descripcio}}</span></label>
          </ng-container>
        </blockquote>
      </div>
    </div>
  </div>
</form>

<div class="button-bar">
  <button class="main" (click)="goToPrevStep()"><i class="fas fa-angle-left prev" aria-hidden></i> {{'globals.anterior' | translate}}</button>
  <button class="main" (click)="goToNextStep()">{{'globals.seguent' | translate}} <i class="fas fa-angle-right next" aria-hidden></i></button>
</div>

<vn-modal id="errors" title="{{'globals.revisar_camps' | translate}}" movible>
  <ng-container>
    <ul *ngFor="let error of errors">
      <li>{{error}}</li>
    </ul>
  </ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>